"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStockLabelValue = exports.isBuiltInLabelType = exports.localizeCategoryAndLabel = exports.localizeLabelValueCategory = exports.localizeCategory = exports.labelCategoryToIcon = exports.localizeLabelValueName = exports.localizeLabelTypeName = exports.labelTypeToString = exports.stringtoLabelType = exports.LabelType = void 0;
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const CertifiedBaseIcon_1 = require("@tableau/icons/CertifiedBaseIcon");
const KeyVerticalOutlineIcon_1 = require("@tableau/icons/KeyVerticalOutlineIcon");
const RESERVEDDatasourceCanInfoIcon_1 = require("@tableau/icons/RESERVEDDatasourceCanInfoIcon");
const RESERVEDDatasourceCanWarningIcon_1 = require("@tableau/icons/RESERVEDDatasourceCanWarningIcon");
const Styles_1 = require("../Styles");
const LabelCategories_1 = require("./LabelCategories");
var LabelType;
(function (LabelType) {
    LabelType[LabelType["WARNING"] = 0] = "WARNING";
    LabelType[LabelType["DEPRECATED"] = 1] = "DEPRECATED";
    LabelType[LabelType["STALE"] = 2] = "STALE";
    LabelType[LabelType["MAINTENANCE"] = 3] = "MAINTENANCE";
    LabelType[LabelType["SENSITIVE_DATA"] = 4] = "SENSITIVE_DATA";
    LabelType[LabelType["EXTRACT_REFRESH_FAILURE"] = 5] = "EXTRACT_REFRESH_FAILURE";
    LabelType[LabelType["FLOW_RUN_FAILURE"] = 6] = "FLOW_RUN_FAILURE";
    LabelType[LabelType["CERTIFIED"] = 7] = "CERTIFIED";
    LabelType[LabelType["CUSTOM_LABEL_VALUE"] = 8] = "CUSTOM_LABEL_VALUE";
})(LabelType = exports.LabelType || (exports.LabelType = {}));
function stringtoLabelType(type) {
    switch (type) {
        case LabelType[LabelType.WARNING]:
            return LabelType.WARNING;
        case LabelType[LabelType.DEPRECATED]:
            return LabelType.DEPRECATED;
        case LabelType[LabelType.STALE]:
            return LabelType.STALE;
        case LabelType[LabelType.MAINTENANCE]:
            return LabelType.MAINTENANCE;
        case LabelType[LabelType.SENSITIVE_DATA]:
            return LabelType.SENSITIVE_DATA;
        case LabelType[LabelType.EXTRACT_REFRESH_FAILURE]:
            return LabelType.EXTRACT_REFRESH_FAILURE;
        case LabelType[LabelType.FLOW_RUN_FAILURE]:
            return LabelType.FLOW_RUN_FAILURE;
        case LabelType[LabelType.CERTIFIED]:
            return LabelType.CERTIFIED;
        default:
            return LabelType.CUSTOM_LABEL_VALUE;
    }
}
exports.stringtoLabelType = stringtoLabelType;
function labelTypeToString(type) {
    return LabelType[type];
}
exports.labelTypeToString = labelTypeToString;
function localizeLabelTypeName(type) {
    switch (type) {
        case LabelType.WARNING:
            return catalog_messages_1.Messages.DataQualityTypeWarning();
        case LabelType.DEPRECATED:
            return catalog_messages_1.Messages.DataQualityTypeDeprecated();
        case LabelType.STALE:
            return catalog_messages_1.Messages.DataQualityTypeStale();
        case LabelType.MAINTENANCE:
            return catalog_messages_1.Messages.DataQualityTypeMaintenance();
        case LabelType.SENSITIVE_DATA:
            return catalog_messages_1.Messages.DataQualityTypeSensitiveData();
        case LabelType.EXTRACT_REFRESH_FAILURE:
            return catalog_messages_1.Messages.DataQualityTypeExtractRefreshFailure();
        case LabelType.FLOW_RUN_FAILURE:
            return catalog_messages_1.Messages.DataQualityTypeFlowRunFailure();
        case LabelType.CERTIFIED:
            return catalog_messages_1.Messages.DataQualityTypeCertified();
        case LabelType.CUSTOM_LABEL_VALUE:
            // if we try to localize a custom label value, return empty and use label value as is
            return '';
        default:
            (0, catalog_core_1.assertUnreachable)(type);
            return '';
    }
}
exports.localizeLabelTypeName = localizeLabelTypeName;
function localizeLabelValueName(name) {
    switch (name) {
        case 'WARNING':
            return catalog_messages_1.Messages.DataQualityTypeWarning();
        case 'DEPRECATED':
            return catalog_messages_1.Messages.DataQualityTypeDeprecated();
        case 'STALE':
            return catalog_messages_1.Messages.DataQualityTypeStale();
        case 'MAINTENANCE':
            return catalog_messages_1.Messages.DataQualityTypeMaintenance();
        case 'SENSITIVE_DATA':
            return catalog_messages_1.Messages.DataQualityTypeSensitiveData();
        case 'EXTRACT_REFRESH_FAILURE':
            return catalog_messages_1.Messages.DataQualityTypeExtractRefreshFailure();
        case 'FLOW_RUN_FAILURE':
            return catalog_messages_1.Messages.DataQualityTypeFlowRunFailure();
        case 'CERTIFIED':
            return catalog_messages_1.Messages.DataQualityTypeCertified();
        default:
            return name;
    }
}
exports.localizeLabelValueName = localizeLabelValueName;
function labelCategoryToIcon(category, isSevere) {
    switch (category) {
        case 'CERTIFICATION':
            return (0, CertifiedBaseIcon_1.CertifiedBaseIcon)({ size: 14 });
        case 'WARNING':
            return isSevere
                ? (0, RESERVEDDatasourceCanWarningIcon_1.RESERVEDDatasourceCanWarningIcon)({ size: 14, color: Styles_1.WarningLabelSevereColor })
                : (0, RESERVEDDatasourceCanInfoIcon_1.RESERVEDDatasourceCanInfoIcon)({ size: 14, color: Styles_1.WarningLabelColor });
        case 'SENSITIVITY':
            return (0, KeyVerticalOutlineIcon_1.KeyVerticalOutlineIcon)({ size: 14, color: isSevere ? Styles_1.SensitiveLabelColor : Styles_1.SensitiveLabelNeutralColor });
        default:
            return null;
    }
}
exports.labelCategoryToIcon = labelCategoryToIcon;
function localizeCategory(category) {
    switch (category) {
        case 'CERTIFICATION':
            return catalog_messages_1.Messages.Certification();
        case 'WARNING':
            return catalog_messages_1.Messages.DataQualityWarningTitle();
        case 'SENSITIVITY':
            return catalog_messages_1.Messages.SensitivityTitle();
        default:
            return category;
    }
}
exports.localizeCategory = localizeCategory;
function localizeLabelValueCategory(category, type) {
    switch (category) {
        case 'CERTIFICATION':
            return catalog_messages_1.Messages.Certification();
        case 'SENSITIVITY':
            return catalog_messages_1.Messages.ColumnHeaderSensitivity();
        case 'WARNING':
            // Warnings have different category name display based on whether it allows custom values or not
            return isBuiltInLabelType(type)
                ? `${catalog_messages_1.Messages.DataQualityTypeWarning()} - ${localizeLabelTypeName(stringtoLabelType(type))}` // e.g. Warning - Extract refresh failed
                : catalog_messages_1.Messages.DataQualityWarningTitle(); // Data Quality Warning
        default:
            return category;
    }
}
exports.localizeLabelValueCategory = localizeLabelValueCategory;
function localizeCategoryAndLabel(category, value) {
    const template = catalog_messages_1.Messages.LabelsDialog_Heading({ category: '[CATEGORY-TOKEN]', value: '[VALUE-TOKEN]' });
    return (0, catalog_core_1.interpolateString)(template, {
        'CATEGORY-TOKEN': localizeCategory(category),
        'VALUE-TOKEN': localizeLabelValueName(value),
    })
        .join('');
}
exports.localizeCategoryAndLabel = localizeCategoryAndLabel;
const BuiltInLabelTypes = [LabelType.CERTIFIED, LabelType.EXTRACT_REFRESH_FAILURE, LabelType.FLOW_RUN_FAILURE];
function isBuiltInLabelType(labelType) {
    return BuiltInLabelTypes.includes(stringtoLabelType(labelType));
}
exports.isBuiltInLabelType = isBuiltInLabelType;
function isStockLabelValue(labelCategory, labelValue) {
    if (!(0, LabelCategories_1.isBuiltInLabelCategory)(labelCategory)) {
        return false;
    }
    return Object.values(LabelType).includes(labelValue);
}
exports.isStockLabelValue = isStockLabelValue;
//# sourceMappingURL=LabelType.js.map